module.exports = __webpack_public_path__ + "img/section4_m.fea7bad3.jpg";